import React from 'react';
import { MdImportantDevices, MdLoyalty } from 'react-icons/md';
import { SidebarContext } from '../../context/SidebarContext';
import { AppWrapper } from '../../constants/styledComponents';
import { Content, Footer, Header, Sidebar } from '.';

class MainLayout extends React.Component {
  static contextType = SidebarContext;
  componentDidMount() {
    this.checkBreakpoint(this.props.breakpoint);

    setTimeout(() => {
      if (!this.notificationSystem) {
        return;
      }

      this.notificationSystem.addNotification({
        title: <MdImportantDevices />,
        message: 'Welcome to SONDA Admin!',
        level: 'info',
      });
    }, 1500);

    setTimeout(() => {
      if (!this.notificationSystem) {
        return;
      }

      this.notificationSystem.addNotification({
        title: <MdLoyalty />,
        message:
          'SONDA is developed by Reyedar B.V.!',
        level: 'info',
      });
    }, 2500);
  }

  // close sidebar when
  handleContentClick = () => {
    const { isSidebarOpen, closeSidebar } = this.context;

    if (
      isSidebarOpen &&
      ['xs', 'sm', 'md'].includes(this.props.breakpoint)
    ) {
      closeSidebar();
    }
  };

  checkBreakpoint(breakpoint) {
    const { openSidebar, closeSidebar } = this.context;

    if (['xs', 'sm', 'md'].includes(breakpoint)) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }

  render() {
    const { children } = this.props;
    const { isSidebarOpen } = this.context;

    return (
      <AppWrapper>
        <Sidebar />
        <Content isSidebarOpen={isSidebarOpen} onClick={this.handleContentClick}>
          <Header currentUser={this.props.currentUser} />
          {children}
          <Footer />
        </Content>
      </AppWrapper>
    );
  }
}

export default MainLayout;
